export type WizardStep =
  | 'select-type'
  | 'select-customer'
  | 'select-items'
  | 'payments'
  | 'review'
  | 'success';

export type DocCategory = 'invoice' | 'receipt' | 'delivery_note';

export interface DocCategoryConfig {
  id: DocCategory;
  icon: string;
  titleKey: string;
  descKey: string;
  color: string;
  bgColor: string;
  borderColor: string;
}

export interface RivhitCustomer {
  customer_id: number;
  last_name: string;
  first_name: string;
  email?: string;
  phone?: string;
  street?: string;
  city?: string;
}

export interface RivhitItem {
  item_id?: number;
  item_name?: string;
  catalog_number?: string;
  item_group_id?: number;
  item_group_name?: string;
  price?: number;
  cost?: number;
  quantity_type?: string;
  barcode?: string;
  is_active?: boolean;
}

export interface SelectedCustomer {
  customer_id: number | null;
  display_name: string;
  is_free_text: boolean;
}

export interface DocType {
  document_type: number;
  document_name: string;
  is_invoice_receipt: boolean;
  is_accounting: boolean;
  price_include_vat: boolean;
}

export interface ReceiptType {
  receipt_type: number;
  receipt_name: string;
  is_invoice_receipt: boolean;
}

export interface PaymentTypeItem {
  payment_type: number;
  payment_name: string;
  type_code: number;
}

export interface Product {
  id: string;
  name: string;
  name_he?: string;
  category?: string;
  unit: string;
  price?: number;
  makat?: string;
}

export interface SelectedItem {
  id: string;
  item_id?: number;
  catalog_number?: string;
  description: string;
  quantity: number;
  price: number;
  unit: string;
  is_custom: boolean;
}

export interface PaymentLine {
  payment_type: number;
  payment_name: string;
  amount: number;
}

export interface CreatedDocument {
  document_type: number;
  document_number: number;
  document_link?: string;
  print_status?: number;
  customer_id?: number;
}

export interface AssistantPrefillCustomer {
  customer_id: number | null;
  display_name: string;
  is_free_text?: boolean;
}

export interface AssistantPrefillItem {
  product_id?: string;
  item_id?: number;
  catalog_number?: string;
  description: string;
  quantity: number;
  price?: number | null;
  unit?: string;
  is_custom?: boolean;
}

export interface AssistantDetectedCapability {
  id: string;
  label: string;
  value: string;
  confidence?: number | null;
}

export interface AssistantDocumentPrefill {
  source?: 'agent_chat';
  category?: DocCategory | null;
  customer?: AssistantPrefillCustomer | null;
  items?: AssistantPrefillItem[];
  comments?: string;
  selected_document_option_id?: string | null;
  detected_capabilities?: AssistantDetectedCapability[];
}

export interface WizardData {
  category: DocCategory | null;
  docType: number | null;
  receiptType: number | null;
  priceIncludeVat: boolean;
  customer: SelectedCustomer | null;
  items: SelectedItem[];
  payments: PaymentLine[];
  comments: string;
  createdDoc: CreatedDocument | null;
}

export const initialWizardData: WizardData = {
  category: null,
  docType: null,
  receiptType: null,
  priceIncludeVat: true,
  customer: null,
  items: [],
  payments: [],
  comments: '',
  createdDoc: null,
};

export const DOC_CATEGORIES: DocCategoryConfig[] = [
  {
    id: 'invoice',
    icon: '📄',
    titleKey: 'createDocument.types.invoice',
    descKey: 'createDocument.types.invoiceDesc',
    color: 'text-blue-700',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-300',
  },
  {
    id: 'receipt',
    icon: '🧾',
    titleKey: 'createDocument.types.receipt',
    descKey: 'createDocument.types.receiptDesc',
    color: 'text-green-700',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-300',
  },
  {
    id: 'delivery_note',
    icon: '🚚',
    titleKey: 'createDocument.types.deliveryNote',
    descKey: 'createDocument.types.deliveryNoteDesc',
    color: 'text-orange-700',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-300',
  },
];
